import { useState } from 'react';
import { UpChunk } from '@mux/upchunk';
import { useRequestUploadVOD } from '~/requests/videoOnDemandService/useRequestUploadVOD';

interface UploadProgress {
  detail: {
    percent: number;
  };
}

export const useVideoOnDemandUploadVideo = () => {
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [isUploading, setIsUploading] = useState(false);
  const { uploadVideo, vodUploadError, isVodVideoUploadSuccess } = useRequestUploadVOD();

  const handleFileUpload = async (file: File, videoId: string) => {
    try {
      setIsUploading(true);

      await new Promise((resolve, reject) => {
        uploadVideo(
          { videoId },
          {
            onSuccess: (response) => {
              if (response?.uploadUrl) {
                const upload = UpChunk.createUpload({
                  endpoint: response.uploadUrl,
                  file,
                  chunkSize: 5120, // 5MB chunks
                });

                upload.on('error', (err) => {
                  console.error('Upload error:', err);
                  setIsUploading(false);
                  reject(err);
                });

                upload.on('progress', (progress: UploadProgress) => {
                  if (progress?.detail?.percent > 0) {
                    setUploadProgress(progress.detail.percent);
                  }
                });
                upload.on('chunkSuccess', ({ detail }) => {
                  const uploaded = (detail.chunk + 1) * 5120;
                  const progress = Math.round((uploaded / (file.size / 1024)) * 100);
                  setUploadProgress(progress);
                });
                upload.on('success', () => {
                  setIsUploading(false);
                  setUploadProgress(100);
                  resolve(true);
                });
              }
            },
            onError: (error) => {
              setIsUploading(false);
              reject(error);
            },
          },
        );
      });
    } catch (error) {
      console.error('Error initiating upload:', error);
      setIsUploading(false);
    }
  };

  return {
    handleFileUpload,
    uploadProgress,
    isUploading,
    uploadError: vodUploadError,
    isUploadSuccess: isVodVideoUploadSuccess,
  };
};

export default useVideoOnDemandUploadVideo;
